module.exports = __webpack_public_path__ + "img/BrandMe_IA_Perro_5.6f604f87.png";